export default "__VITE_ASSET__Bvm9jmiA__"